module.exports = __webpack_public_path__ + "img/icon-slide3.622d9756.jpg";